/* One module for every /programs/<slug> page that is not JMA, so the
   page bundle registry (src/pages/registry.js) needs no program data
   in the first download. Spec pages (owner master specs) and template
   pages each keep their own component. */
import React from "react";
import ProgramPage from "./ProgramPage";
import ProgramSpecPage from "./ProgramSpecPage";
import { PROGRAM_PAGE_SLUGS } from "../../data/programPages";
import { PROGRAM_SPEC_SLUGS } from "../../data/programSpecs";

export default function ProgramRoute({ slug }) {
  if (PROGRAM_SPEC_SLUGS.includes(slug)) return <ProgramSpecPage slug={slug} />;
  if (PROGRAM_PAGE_SLUGS.includes(slug)) return <ProgramPage slug={slug} />;
  throw new Error(`src/seo/site.mjs lists /programs/${slug} but no program data has that slug.`);
}
